import React, {PropTypes} from 'react';
import {reduxForm, Field} from 'redux-form';
import Submitting from 'shared/Submitting.jsx';
import StandardField from 'shared/StandardField.jsx';
import StandardSelectField from 'shared/StandardSelectField.jsx';
import StandardCheckboxField from 'shared/StandardCheckboxField.jsx';
import TimeField from 'shared/TimeField.jsx';
import DisplayIf from 'shared/DisplayIf.jsx';
import SquadDeleteModalContainer from './SquadDeleteModalContainer.jsx';
import SquadDeleteConfirmModalContainer from './SquadDeleteConfirmModalContainer.jsx';

const daysOfWeek = [
  'Sun',
  'Mon',
  'Tue',
  'Wed',
  'Thu',
  'Fri',
  'Sat'
];

const SquadForm = ({
  timeZoneDisplay,
  eventTypes,
  handleSubmit,
  minDateUntil,
  pristine,
  submitting,
  canRepeat,
  onCancel,
  onSubmit,
  confirmDelete,
  canDelete,
  tmsEndpoint,
  status
}) => (
  <form
    onSubmit={handleSubmit(onSubmit)}
  >
    <Field
      name="eventId"
      component={StandardSelectField}
      options={eventTypes}
      placeholder="Event Type"
      simpleValue
      searchable={false}
    />

    <Field
      name="time"
      component={TimeField}
      placeholder={`Time (${timeZoneDisplay})`}
    />

    <Field
      name="startLane"
      type="number"
      step="1"
      min="0"
      component={StandardField}
      placeholder="Start Lane"
      tooltip="Must be an odd number."
      tooltipPosition="top"
    />

    <Field
      name="endLane"
      type="number"
      step="1"
      min="0"
      component={StandardField}
      placeholder="End Lane"
      tooltip="Must be an even number. Managers can only increase the number of lanes."
      tooltipPosition="top"
    />

    <DisplayIf condition={canRepeat}>
      <fieldset className="repeaton">
        <Field
          name="repeaton"
          type="hidden"
          component={StandardField}
          label="Repeat On"
          tooltip="Select a day or days to repeat the event at the exact same day/time of the week until the end date selected. Example: Repeat the Singles event every Saturday and Sunday at 09:00am"
          tooltipPosition="top"
        />
        <div className="horizontal-checkbox-group">
          {daysOfWeek.map((day, index) =>
            <Field
              name={`repeatOn.${index}`}
              key={index}
              component={StandardCheckboxField}
              label={day}
            />
          )}
        </div>
        <Field
          name="until"
          type="date"
          minDate={minDateUntil}
          component={StandardField}
          placeholder="Until"
        />
      </fieldset>
    </DisplayIf>
    <hr />

    <div className="form-group text-right">
    { canDelete && tmsEndpoint === null &&
      <span style={{paddingRight: 270}}>
         <button
          type="button"
          className="btn btn-danger btn-lg"
          disabled={status !== 'Setup' || submitting}
          onClick={confirmDelete}
        >Delete</button>
        </span> }
        <button
          type="button"
          className="btn btn-link"
          disabled={submitting}
          onClick={onCancel}
        >Cancel</button>
        {` `}
        <button
          type="submit"
          className="btn btn-primary btn-lg"
          disabled={pristine || submitting}
        >{submitting ? <Submitting /> : <i className="fa fa-floppy-o" />} {'Save'}</button>
      </div>
      <SquadDeleteModalContainer/>
      <SquadDeleteConfirmModalContainer/>
  </form>
);

SquadForm.propTypes = {
  timeZoneDisplay: PropTypes.string,
  minDateUntil: PropTypes.string,
  eventTypes: PropTypes.arrayOf(PropTypes.object),
  status: PropTypes.string,
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  canRepeat: PropTypes.bool,
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
  onDelete: PropTypes.func
};

export default reduxForm({
  form: 'tournamentSquadForm'
})(SquadForm);



// WEBPACK FOOTER //
// ./src/features/tournament/squads/SquadForm.jsx